import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  IconButton,
  Typography,
  Grid,
  Paper,
  Slide,
  Dialog,
  DialogContent,
  AppBar,
  Toolbar,
  Button
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import LoadingButton from '../components/LoadingButton'
import LoadingCircle from '../components/common/LoadingCircle'
import { smallScreenWidth } from '../constants/AppConstants'
import AssetDetail from '../components/AssetDetail'
import { useAm70ReactTableCols } from '../hooks/AssetCols'
import fetchFromAthena from '../functions/FetchFromAthena'
import { DashboardAthenaTable } from '../components/DashboardAthenaTable'
import OpenSearchDropdown from '../components/OpenSearchDropdown'


const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: '2rem 1rem'
  },
  footerCell: {
    backgroundColor: '#F5F5F5',
    borderBottom: 'none',
    zIndex: 999
  },
  stickyFooterCell: {
    position: 'sticky',
    bottom: 0,
    zIndex: 100
  },
  rightTableHead: {
    '& > span': {
      justifyContent: 'flex-end',
      marginRight: '0'
    }
  },
  appBar: {
    position: 'relative',
    backgroundColor: props => props.primaryColor,
    height: '60px'
  }
}))

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

const defaultHeaders = {
  company: '',
  leaseCompany: '',
  lease: '',
  location: '',
  division: '',
  assetType: '',
  subType: '',
  assetGroup: ''
}
export default function AssetAnalysisServerSide(props) {
  const [state, setstate] = useState({
    isLoading: false,
    data: null,
    fetched: false,
    tableKey: JSON.stringify(defaultHeaders)
  })
  const [headers, setHeaders] = useState(defaultHeaders)
  const [showTable, setShowTable] = useState(false)

  const [clearHeader, setClearHeaders] = React.useState(false)
  const [clearTrigger, setClearTrigger] = React.useState(false)
  const [assetData, setAssetData] = useState({
    open: false,
    assetData: null,
    items: [],
    books: []
  })

  const am70ReactTableCols = useAm70ReactTableCols()

  const { credentials } = props.fetchInitialData
  const classes = useStyles({ primaryColor: credentials.primaryAppColor })

  const handleSubmit = e => {
    e.preventDefault()
    if (JSON.stringify(headers) === state.tableKey) return null
    setShowTable(true)
    setstate({ ...state, isLoading: true, tableKey: JSON.stringify(headers) })
  }
  const handleCallback = (values, error) => {
    if (error) {
      setstate({ ...state, isLoading: false })
      setShowTable(false)
      return null
    }
    setstate({ ...state, isLoading: false })
  }

  const tableDataTransformation = rows => {
    return rows.map(row => {
      return {
        ...row,
        ASSET_LINK: (
          <div
            className='editLink'
            onClick={() => getAsset(row.COMPANY, row.ASSET)}
          >
            {row.ASSET}
          </div>
        )
      }
    })
  }
  const getAsset = async (comp, id) => {
    try {
      if (!id || !comp) return null
      setAssetData({ ...assetData, open: true })

      const queries = ['am_asset_read', 'am_item_read', 'am_book_read']

      const data = await Promise.allSettled(
        queries.map(query =>
          fetchFromAthena({
            queryName: query,
            headers: {
              company: comp,
              asset: id
            },
            accessToken: credentials.user.accessToken,
            credentials: credentials
          })
        )
      ).then(results => {
        return results
      })

      const [main, items, books] = [
        data[0].value[0],
        data[1].value,
        data[2].value
      ]

      if(!main) {
        props.createSnack('Asset not found or secured', 'warning', 3000)
        setAssetData({ ...state, isLoading: false });
        return
      }

      const assetDesc = main.ASSET_DESC
      setAssetData({
        ...assetData,
        assetData: main,
        open: true,
        items: items.map(row => {
          return {
            ...row,
            COMPANY: comp,
            ASSET: id,
            ASSET_DESC: assetDesc
          }
        }),
        books: books.map(row => {
          return {
            ...row,
            COMPANY: comp,
            ASSET: id,
            ASSET_DESC: assetDesc
          }
        }),
        isLoading: false
      })
    } catch (e) {
      console.log(e)
    }
  }

  // if (!state.fetched) {
  //   return <LoadingCircle />
  // }

  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>
      <Dialog
        open={assetData.open}
        TransitionComponent={Transition}
        maxWidth='xl'
        fullWidth
        fullScreen={
          props.fetchInitialData.credentials.appWidth < smallScreenWidth
            ? true
            : false
        }
        scroll='body'
        keepMounted
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge='start'
              color='inherit'
              onClick={() =>
                setAssetData({
                  ...assetData,
                  assetData: null,
                  items: [],
                  books: [],
                  open: false
                })
              }
              aria-label='close'
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        {assetData.open && (
          <DialogContent style={{ padding: 0 }}>
            {!!assetData.assetData ? (
              <AssetDetail
                {...props}
                assetData={assetData.assetData}
                items={assetData.items}
                books={assetData.books}
              />
            ) : (
              <LoadingCircle />
            )}
          </DialogContent>
        )}
      </Dialog>

      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size='small'
        onClick={() => props.history.push('/')}
        aria-label='delete'
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      <Typography variant='h5' style={{ textAlign: 'center' }}>
        Asset Analysis (AM70.1)
      </Typography>

      <div className={classes.root}>
        <Paper elevation={0} style={{ padding: '1rem' }}>
          <form onSubmit={handleSubmit}>
            <Grid
              container
              alignContent='center'
              alignItems='flex-start'
              spacing={3}
            >
              <Grid item>
                <OpenSearchDropdown
                  id='company'
                  required
                  width='150px'
                  label='Company'
                  page="ASSET"
                  entity="COMPANY"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, company: val?.VALUE || '' })
                  }}
                />
              </Grid>
              {/*<Grid item>*/}
              {/*  <OpenSearchDropdown*/}
              {/*    id='leaseCompany'*/}
              {/*    required={false}*/}
              {/*    width='150px'*/}
              {/*    label='Lease Company'*/}
              {/*    page="ASSETANALYSIS"*/}
              {/*    entity="LEASECOMPANY"*/}
              {/*    searchFields={['DISPLAY']}*/}
              {/*    accessToken={credentials.user.accessToken}*/}
              {/*    credentials={credentials}*/}
              {/*    clearTrigger={clearTrigger}*/}
              {/*    onChange={(val) => {*/}
              {/*      setHeaders({ ...headers, leaseCompany: val?.VALUE || '' })*/}
              {/*    }}*/}
              {/*  />*/}
              {/*</Grid>*/}
              {/*<Grid item>*/}
              {/*  <OpenSearchDropdown*/}
              {/*    id='lease'*/}
              {/*    required={false}*/}
              {/*    width='150px'*/}
              {/*    label='Lease'*/}
              {/*    page="ASSETANALYSIS"*/}
              {/*    entity="LEASE"*/}
              {/*    searchFields={['DISPLAY']}*/}
              {/*    accessToken={credentials.user.accessToken}*/}
              {/*    credentials={credentials}*/}
              {/*    clearTrigger={clearTrigger}*/}
              {/*    onChange={(val) => {*/}
              {/*      setHeaders({ ...headers, lease: val?.VALUE || '' })*/}
              {/*    }}*/}
              {/*  />*/}
              {/*</Grid>*/}
              <Grid item>
                <OpenSearchDropdown
                  id='location'
                  required={false}
                  width='170px'
                  label='Location'
                  page="ASSETANALYSIS"
                  entity="LOCATION"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, location: val?.VALUE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='division'
                  required={false}
                  width='150px'
                  label='Division'
                  page="ASSETANALYSIS"
                  entity="DIVISION"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, division: val?.VALUE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='assetType'
                  required={false}
                  width='150px'
                  label='Asset Type'
                  page="ASSETANALYSIS"
                  entity="ASSETTYPE"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, assetType: val?.VALUE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='subType'
                  required={false}
                  width='150px'
                  label='Sub Type'
                  page="ASSETANALYSIS"
                  entity="SUBTYPE"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, subType: val?.VALUE || '' })
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='assetGroup'
                  required={false}
                  width='150px'
                  label='Asset Group'
                  page="ASSETANALYSIS"
                  entity="GROUP"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setHeaders({ ...headers, assetGroup: val?.VALUE || '' })
                  }}
                />
              </Grid>
            </Grid>
            <div style={{ marginTop: '1rem' }}>
              <LoadingButton
                label='Submit'
                isLoading={state.isLoading}
                color='primaryVLButton'
                buttonType='submit'
              />
              {!!Object.values(headers).some(value => value !== '') && (
                <Button
                  onClick={() => {
                    setClearHeaders(!clearHeader)
                    setHeaders(defaultHeaders)
                    setClearTrigger(prev => !prev)
                  }}
                  style={{ marginLeft: '0.5rem' }}
                >
                  Clear
                </Button>
              )}
            </div>
          </form>
        </Paper>

        {showTable && (
          <div style={{ marginTop: '1rem ' }}>
            <DashboardAthenaTable
              {...props}
              isTempTable={true}
              key={state.tableKey}
              params={{ ...headers }}
              tableColumns={am70ReactTableCols}
              reportParamName="am_am70_read_serverside"
              reportName='am_am70_read_serverside_temp'
              tableTitle={''}
              callback={handleCallback}
              transform={tableDataTransformation}
              downloadFileName={'Asset_Analysis_Download'}
              separatedDateFilters={{
                PURCHASE_DATE: ['PURCHASE_DATE_FROM', 'PURCHASE_DATE_TO'],
              }}
            />

          </div>
        )}
      </div>
    </div>
  )
}
